"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePermissionsCard = void 0;
var react_1 = __importDefault(require("react"));
var BasePermissionsCard = function (_a) {
    var permissionsSlot = _a.permissionsSlot, avatarSlot = _a.avatarSlot, nameSlot = _a.nameSlot, descriptionSlot = _a.descriptionSlot;
    return (react_1.default.createElement("div", { className: "base-permissions-card" },
        react_1.default.createElement("div", { className: "base-permissions-card__avatar" }, avatarSlot),
        react_1.default.createElement("div", { className: "permission-details" },
            react_1.default.createElement("div", { className: "permission-details__name" }, nameSlot),
            descriptionSlot && react_1.default.createElement("div", { className: "permission-details__email" }, descriptionSlot)),
        permissionsSlot));
};
exports.BasePermissionsCard = BasePermissionsCard;
